import { FC } from 'react'
import { Tag } from 'components/Global/Tag'

type ProductTagsProps = {
  isPreorder?: boolean
  isBackorder?: boolean
  discountAmount?: number
  className?: string
}

export const ProductTags: FC<ProductTagsProps> = (props) => {
  const { isPreorder, isBackorder, discountAmount, className } = props

  if (!isPreorder && !isBackorder && !discountAmount) return null

  return (
    <div className={`${className} flex flex-wrap items-start gap-4`}>
      {isPreorder && <Tag className="bg-yellow text-black">Preorder</Tag>}
      {isBackorder && <Tag className="bg-yellow text-black">Backorder</Tag>}
      {discountAmount && (
        <Tag className="bg-yellow text-black">Save {discountAmount}</Tag>
      )}
    </div>
  )
}
